module.exports = fox._r("images/lang/en.png", __webpack_public_path__ + "_/_/_/common/frame/images/lang/en.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/lang/en.png
// module id = 109
// module chunks = 2